import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./SpinnerOverlay.scss');
function SpinnerOverlay(props: {}) {
    return <Spinner className={styles.linkSpinner} size={SpinnerSize.xSmall} />;
}

export function displaySpinnerOverlay(spinnerContainer: HTMLElement) {
    ReactDOM.render(<SpinnerOverlay />, spinnerContainer);
}
